import React, { Component } from "react";
import { Tabs } from "antd";
import { connect } from "dva";
import { parse } from "qs";
import styles from "./index.less";
import EvaluationSelfTree from "./EvaluationSelfTree";
import Container from "../../../../../components/Container";

const { TabPane } = Tabs;

@connect(({ project }) => ({
  existOrg: project.existOrg
}))
class index extends Component {
  constructor(props) {
    super(props);
    const { search } = window.location;
    const query = parse(search.split("?").pop());
    const { currentProjectId, nowOrgId } = query;
    this.currentProjectId = currentProjectId;
    this.currentOrgId = nowOrgId;
    this.state = {
      activeKey: "1"
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({
      type: "project/fetchGetExistOrg",
      payload: {
        projectId: this.currentProjectId,
        respondentOrgId: this.currentOrgId
      }
    });
  }

  // 修改tab
  handleChangeTab = activeKey => {
    this.setState({
      activeKey
    });
  };

  render() {
    const { activeKey } = this.state;
    const { existOrg } = this.props;
    const containerProps = {
      breStates: true,
      version: 2,
      defaultPadding: true,
      isPathParams: true
    };
    return (
      <Container {...containerProps}>
        <div className={styles.root}>
          <Tabs
            type="card"
            onChange={this.handleChangeTab}
            className={`settings-tab${activeKey} common-tab`}
          >
            <TabPane tab="通用指标" key="1">
              {activeKey === "1" && <EvaluationSelfTree {...this.props} />}
            </TabPane>
            {existOrg && (
              <TabPane tab="个性化指标" key="2">
                {activeKey === "2" && (
                  <EvaluationSelfTree {...this.props} org />
                )}
              </TabPane>
            )}
          </Tabs>
        </div>
      </Container>
    );
  }
}

export default index;
